import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Track PWA install
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  
  // Track that install prompt was shown
  trackPWAEvent('pwa_prompt_shown');
});

window.addEventListener('appinstalled', () => {
  trackPWAEvent('pwa_installed');
  deferredPrompt = null;
});

// Helper function to track PWA events
async function trackPWAEvent(eventType) {
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    await fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_type: eventType,
        event_data: {
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent
        }
      })
    });
  } catch (error) {
    console.error('Failed to track event:', error);
  }
}
